<template>
  <div class="page-box">
    <div class="page-content">
      <div class="banner-box">
        <img class="banner-bg" src="/static/images/banner-bg.png" />
        <div class="banner-main-box" v-if="isShow">
          <div class="banner-main">
            <div class="banner-title-box" @click="goMyAppointment">
              <div class="banner-title">我的预约</div>
              <div class="banner-arrow">查看更多<van-icon name="arrow" /></div>
            </div>

            <div class="banner-notice-box" @click="goAppointmentInfo">
              <img class="notice-icon" src="/static/images/notice-icon.png" />
              <div class="notice-text">
                {{ appointmentData.monthDay }}的{{
                  appointmentData.parentName
                }}
                | {{ appointmentData.name }}服务
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="list-box" :class="{ 'no-appointment': !isShow }">
        <div class="list-main">
          <div class="banner-title-box">
            <div class="banner-title">可预约的服务</div>
          </div>

          <div
            class="list-item"
            :class="{ 'border-bottom-none': serviceList.length - 1 === index }"
            v-for="(item, index) in serviceList"
            :key="index"
          >
            <van-image :src="item.coverUrl" fit="cover" />
            <div class="item-info">
              <div class="item-title">{{ item.name }}</div>
              <div class="item-desc">{{ item.description }}</div>
              <div class="item-time" v-if="item.businessHours">
                <img class="time-icon" src="/static/images/time-icon.png" />
                <div>营业时间：{{ item.businessHours }}</div>
              </div>
              <div class="item-phone"><img class="time-icon" src="/static/images/phone.png" />服务电话：{{ item.serviceTel }}</div>
              <div class="item-price-box">
                <div class="item-price">
                  <template v-if="item.price">
                    <span class="unit1">¥</span>
                    {{ item.price }}
                    <!-- <span class="unit2">/次</span> -->
                  </template>
                </div>

                <div class="operate-btn" @click="appointmentBtn(item)">
                  预约
                </div>
              </div>
            </div>
          </div>

          <van-empty
            class="custom-image"
            v-if="!serviceList.length"
            image="https://img.yzcdn.cn/vant/custom-empty-image.png"
            description="暂无可预约的服务"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { homeList, appointmentList } from "@/api/index";
export default {
  data() {
    return {
      serviceList: [],
      isShow: false,
      appointmentData: {},
    };
  },
  mounted() {
    console.log(
      "store",
      this.$store.state,
      "sessionStorage",
      sessionStorage.getItem("token")
    );
    if (this.$store.state.userInfo && this.$store.state.userInfo.token) {
      this.getServiceList();
      this.getAppointmentList();
    }
  },
  methods: {
    // 预约
    appointmentBtn(item) {
      this.$router.push({
        name: "service-make-an-appointment",
        query: {
          primaryKey: item.primaryKey,
        },
      });
    },
    // 获取服务列表
    async getServiceList() {
      let res = await homeList({
        channelId: this.$route.query.channelId
          ? this.$route.query.channelId
          : "36afd48ed2d0479f9c242107bdb31708",
      });
      this.serviceList = res.data.rows;
    },
    // 获取预约列表
    async getAppointmentList() {
      let res = await appointmentList();
      if (res.data.length) {
        this.isShow = true;
        this.appointmentData = res.data[0];
      } else {
        this.isShow = false;
      }
    },
    // 预约详情
    goAppointmentInfo() {
      this.$router.push({
        name: "order-details",
        query: {
          orderKey: this.appointmentData.primaryKey,
        },
      });
    },
    goMyAppointment() {
      this.$router.push({
        name: "my-make-an-appointment",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  background: #eeeeee;

  .custom-image {
    /deep/ .van-empty__image {
      width: 90px;
      height: 90px;

      img {
        width: 90px;
        height: 90px;
      }
    }
  }
}
.banner-box {
  position: relative;
  height: 250px;

  .banner-bg {
    width: 100%;
    height: 100%;
  }

  .banner-main-box {
    position: absolute;
    top: 205px;
    left: 0;
    width: 100%;
    padding: 0 12px;

    .banner-main {
      padding: 15px 10px;
      background: #fff;
      border-radius: 5px;

      .banner-notice-box {
        margin-top: 10px;
        display: flex;
        align-items: center;

        .notice-icon {
          width: 23px;
          height: 23px;
          margin-right: 6px;
        }

        .notice-text {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #74a98e;
        }
      }
    }
  }
}

.banner-title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .banner-title {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #333333;
    margin-right: 10px;
  }

  .banner-arrow {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;

    .van-icon {
      margin-left: 5px;
    }
  }
}

.list-box {
  margin-top: 50px;
  padding: 0 12px 10px;

  .list-main {
    border-radius: 5px;
    padding: 15px 10px 0;
    background: #fff;

    .list-item {
      padding: 15px 0;
      border-bottom: 1px solid #d8d8d8;
      display: flex;
      align-items: center;

      .van-image {
        border-radius: 5px;
        overflow: hidden;
        width: 120px;
        height: 120px;
      }

      .item-info {
        margin-left: 15px;
        flex: 1;
        min-height: 100px;

        .item-title {
          height: 20px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .item-desc {
          height: 36px;
          font-size: 12px;
          line-height: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
        }

        .item-time {
          height: 20px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          display: flex;
          align-items: center;
          .time-icon {
            width: 13px;
            height: 13px;
            margin-right: 3px;
          }
        }

        .item-phone {
          font-size: 12px;
          line-height: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          display: flex;
          align-items: center;
          .time-icon {
            width: 13px;
            height: 13px;
            margin-right: 3px;
          }
        }

        .item-price-box {
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .item-price {
            display: flex;
            align-items: center;
            color: #16aa77;
            font-size: 15px;
            font-family: PingFangSC-Regular;
            font-weight: 600;
            .unit1 {
              font-size: 12px;
              font-family: PingFangSC-Semibold;
            }
            .unit2 {
              font-size: 12px;
              font-family: PingFangSC-Regular;
              font-weight: normal;
              color: #666666;
            }
          }

          .operate-btn {
            width: 60px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #16aa77;
            border-radius: 12px;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }

    .border-bottom-none {
      border-bottom: none;
    }
  }
}

.no-appointment {
  margin-top: -45px;
  position: relative;
}
</style>
